import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  serviceData: null,
  loaderClass: false,
  isPageExist: false,
};

export const getService = createAsyncThunk(
  "pageService/getService",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`page/services`, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const serviceSlice = createSlice({
  name: "pageService",
  initialState,
  reducers: {
    changeStatus: (state, action) => {
      state.currentService = action.payload;
    },
  },
  extraReducers: {
    [getService.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getService.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state[state.currentService] = action.payload?.data;
      state.isPageExist = action.payload?.success;
      state.loaderClass = true;
    },
    [getService.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export const { changeStatus } = serviceSlice.actions;

export default serviceSlice.reducer;
